import type { CapturedNetworkRequest } from "posthog-js"
import { redactPresignedUrls } from "@/lib/tracing/span-attribute-scrubber"

/**
 * PostHog session recording's network mask (`session_recording.
 * maskCapturedNetworkRequestFn`). `capture_performance` records every
 * request's URL with the recording, and the live viewer's DCV client and the
 * replay's screenshots fetch presigned AWS URLs whose query is a credential
 * and whose path names the AgentCore session. A presigned URL is cut to its
 * host, the same cut the span exporter and the browser logger make
 * (`redactPresignedUrls`); every other request is returned as it was.
 */
export const maskCapturedNetworkRequest = <R extends Pick<CapturedNetworkRequest, "name">>(request: R): R => {
  const name = redactPresignedUrls(request.name)
  return name === request.name ? request : { ...request, name }
}
